<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <!-- Payroll -->
      <v-tab-item>
        <v-autocomplete
          v-model="monthlyReport"
          label="Report Types"
          :items="monthlyReportTypes"
          item-text="name"
          class="pt-5 px-3"
          autofocus
          style="background:white"
        />

        <monthly-payroll-summary
          v-if="monthlyReport === 'Monthly Payroll Summary'"
          class="mb-2"
        />
        <monthly-payroll-details
          v-if="monthlyReport === 'Monthly Payroll Details'"
          class="mb-2"
        />
        <cost-center-payroll-report
          v-if="monthlyReport === 'Monthly Payroll Summary By Cost Center'"
          class="mb-2"
        />
        <company-payroll-report
          v-if="monthlyReport === 'Monthly Payroll Summary By Company'"
          class="mb-2"
        />        
      </v-tab-item>

      <!-- Management-->
      <v-tab-item>
        <v-autocomplete
          v-model="managementReport"
          label="Report Types"
          :items="managementReports"
          item-text="name"
          class="pt-5 px-3"
          style="background:white"
          autofocus
        />

        <yearly-payroll-details-by-individual
          v-if="managementReport === 'Yearly Payroll Details by Individual'"
          class="mb-2"
        />
        <yearly-summary-listing
          v-if="managementReport === 'Yearly Summary Listing'"
          class="mb-2"
        />
        <yearly-payroll-details-by-company
          v-if="managementReport === 'Yearly Payroll Details by Company'"
          class="mb-2"
        />
        <yearly-payroll-details-by-states
          v-if="managementReport === 'Yearly Payroll Details by States'"
          class="mb-2"
        />
        <yearly-payroll-details-by-positions
          v-if="managementReport === 'Yearly Payroll Details by Position'"
          class="mb-2"
        />
        <yearly-payroll-details-by-departments
          v-if="managementReport === 'Yearly Payroll Details by Department'"
          class="mb-2"
        />
        <yearly-earning-report-by-state
          v-if="managementReport === 'Yearly Earning Report by State'"
          class="mb-2"
        />
        <yearly-payroll-details-by-individual-and-company
          v-if="managementReport === 'Yearly Payroll Details by Individual & Company'"
          class="mb-2"
        />
        <monthly-variance-report
          v-if="managementReport === 'Variance Report'"
          class="mb-2"
        />
      </v-tab-item>

      <!-- Employee-->
      <v-tab-item>
        <div>
          <v-container
            class="full-height"
            fluid
          >
            <export-payroll-employee-statutory
              v-if="$hasPermissionTo(['export employee statutory'])"
              class="mb-2"
            />

            <export-payroll-employee-contribution
              v-if="$hasPermissionTo(['export employee contributions'])"
              class="mb-2"
            />
          </v-container>
        </div>               
      </v-tab-item>      
    </v-tabs-items>
    <!-- -->
  </div>
</template>

<script>
  export default {
    components: {
      MonthlyPayrollSummary: () => import('@/components/hris/payroll/report/MonthlyPayrollSummary'),
      MonthlyPayrollDetails: () => import('@/components/hris/payroll/report/MonthlyPayrollDetails'),
      CostCenterPayrollReport: () => import('@/components/hris/payroll/report/CostCenterPayrollReport'),
      CompanyPayrollReport: () => import('@/components/hris/payroll/report/CompanyPayrollReport'),

      YearlyPayrollDetailsByIndividual: () => import('@/components/hris/payroll/report/YearlyPayrollDetailsByIndividual'),
      YearlySummaryListing: () => import('@/components/hris/payroll/report/YearlySummaryListing'),
      YearlyPayrollDetailsByCompany: () => import('@/components/hris/payroll/report/YearlyPayrollDetailsByCompany'),
      YearlyPayrollDetailsByStates: () => import('@/components/hris/payroll/report/YearlyPayrollDetailsByStates'),
      YearlyPayrollDetailsByPositions: () => import('@/components/hris/payroll/report/YearlyPayrollDetailsByPositions'),
      YearlyPayrollDetailsByDepartments: () => import('@/components/hris/payroll/report/YearlyPayrollDetailsByDepartment'),
      YearlyEarningReportByState: () => import('@/components/hris/payroll/report/YearlyEarningReportByState'),
      YearlyPayrollDetailsByIndividualAndCompany: () => import('@/components/hris/payroll/report/YearlyPayrollDetailsByIndividualAndCompany'),
      MonthlyVarianceReport: () => import('@/components/hris/payroll/report/MonthlyVarianceReport'),

      ExportPayrollEmployeeContribution: () => import('@/components/hris/export/payroll/employee-contribution/EmployeeContribution'),
      ExportPayrollEmployeeStatutory: () => import('@/components/hris/export/payroll/employee-statutory/EmployeeStatutory'),      
    },

    data () {
      return {
        tabItems: this.$hasPermissionTo(['view payroll export']) ? [
          { name: 'Monthly Reports' },
          { name: 'Yearly Reports' },
          { name: 'Employee' },
        ] : [
          { name: 'Monthly Reports' },
          { name: 'Yearly Reports' },
        ],
        active: 0,

        monthlyReport: null,
        monthlyReportTypes: [
          { name: 'Monthly Payroll Summary' },
          { name: 'Monthly Payroll Details' },
          { name: 'Monthly Payroll Summary By Cost Center' },
          { name: 'Monthly Payroll Summary By Company' },
        ],

        managementReport: null,
        managementReports: [
          { name: 'Yearly Payroll Details by Individual' },
          { name: 'Yearly Summary Listing' },
          { name: 'Yearly Payroll Details by Company' },
          { name: 'Yearly Payroll Details by States' },
          { name: 'Yearly Payroll Details by Position' },
          { name: 'Yearly Payroll Details by Department' },
          { name: 'Yearly Earning Report by State' },
          { name: 'Yearly Payroll Details by Individual & Company' },
          { name: 'Variance Report' },
        ],
      }
    },
  }
</script>
